import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IConfig, NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { AppMaterialModule } from '@app/app-material.module';
import { ComponentsModule } from '@shared/components/components.module';
import { AnimationsModule } from '@shared/animations/animations.module';
import { AtendimentosComponent } from '@modules/atendimentos/pages/atendimentos/atendimentos.component';
import { AtendimentoController } from '@modules/atendimentos/controllers';
import { AbrirAtendimentoComponent } from '@modules/atendimentos/components/abrir-atendimento/abrir-atendimento.component';
import { DetalhesAtendimentoComponent } from './components/detalhes-atendimento/detalhes-atendimento.component';

const maskConfig: Partial<IConfig> = {
  validation: false,
};

@NgModule({
  declarations: [AtendimentosComponent, AbrirAtendimentoComponent, DetalhesAtendimentoComponent],
  imports: [
    RouterModule,
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    AppMaterialModule,
    ComponentsModule,
    NgxMaskDirective,
    NgxMaskPipe,
    AnimationsModule,
  ],
  providers: [provideNgxMask(maskConfig), AtendimentoController],
})
export class AtendimentosModule {}
